import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["autocomplete"];
const _hoisted_2 = {
    type: "submit",
    value: "Submit",
    class: "hidden"
};
import { computed, watch, ref, nextTick, provide } from 'vue';
import useValidate from 'vue-tiny-validate';
export default /*@__PURE__*/ _defineComponent({
    __name: 'form',
    props: {
        formData: {},
        rules: {},
        autocomplete: { type: Boolean },
        autoValidate: { type: Boolean },
        disabled: { type: Boolean },
        onSubmit: { type: Function }
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const { result } = useValidate(props.formData, props.rules || ref({}));
        const silent = ref(false);
        provide('validation', computed(() => result.value));
        provide('form-disabled', computed(() => props.disabled));
        const validate = () => {
            result.value.$test();
            return !result.value.$invalid;
        };
        watch(() => props.formData, () => {
            if (props.autoValidate)
                validate();
        }, { deep: true });
        __expose({
            validate,
            resetValidate: () => {
                silent.value = true;
                result.value.$reset();
                nextTick(() => silent.value = false);
            },
            invalid: computed(() => result.value.$invalid),
            getErrors: (prop) => (prop ? result.value[prop].$messages : result.value.$messages),
            getCurrentError: (prop) => (prop ? result.value[prop]?.$messages[0] : result.value?.$messages[0]) || '',
            hasError: (prop) => (prop ? result.value[prop].$invalid : result.value.$invalid),
            result
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                autocomplete: _ctx.autocomplete ? 'ON' : 'OFF',
                onSubmit: _cache[0] || (_cache[0] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
            }, [
                _renderSlot(_ctx.$slots, "default"),
                _withDirectives(_createElementVNode("input", _hoisted_2, null, 512), [
                    [_vShow, false]
                ])
            ], 40, _hoisted_1));
        };
    }
});
